
import axiosInstance from '../../Lib/axios';
import {
  CREATE_MESSAGE_FAILED, CREATE_MESSAGE_SUCCESSFULLY,
  GET_ALL_CUSTOMER_LIST_FAILED, GET_ALL_CUSTOMER_LIST_SUCCESSFULLY,
  GET_MESSAGE_FAILED, GET_MESSAGE_SUCCESSFULLY, MESSAGE_COUNT, MESSAGE_COUNT_FAILED, MESSAGE_REPLAY, MESSAGE_REPLAY_FAILED, UPDATE_MESSAGE, UPDATE_MESSAGE_FAILED, GET_REASON_LIST,
  GET_REASON_LIST_FAILED
} from '../types';



// Get all messages
export const getAllMessages = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/message/`, { params })
      .then((response) => {
        dispatch({
          type: GET_MESSAGE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_MESSAGE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get Reason List
export const getReasonList = (params) => {

  return (dispatch) => {
    return axiosInstance
      .get(`/disposition-dropdown/`, { params, })
      .then((response) => {
        dispatch({
          type: GET_REASON_LIST,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/login')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_REASON_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get customer detail
export const getAllCustomerList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/customer-user/`, { params })
      .then((response) => {

        dispatch({
          type: GET_ALL_CUSTOMER_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          window.location.assign('/')
          localStorage.clear();
          sessionStorage.clear();
        }
        if (error?.response) {
          dispatch({
            type: GET_ALL_CUSTOMER_LIST_FAILED,
            data: error?.response?.data,
          });
        }
      });
  };
};



// Create New Tickets
export const createNewTickets = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`crm/message/`, params, {})
      .then((response) => {
        dispatch({
          type: CREATE_MESSAGE_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: CREATE_MESSAGE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

//Replies on Ticket

export const MessageReplies = (params) => {

  return (dispatch) => {
    return axiosInstance.post(`/crm/message-reply/`, params)
      .then((response) => {
        dispatch({
          type: MESSAGE_REPLAY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: MESSAGE_REPLAY_FAILED,
              data: error.response.data,
            });
          }
        }


      });
  };
};

//Read Message
export const readTickets = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/message/${params.uuid}/`, params, {})
      .then(() => { })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_MESSAGE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};



// Update Messages
export const UpdateTickets = (params) => {
  return (dispatch) => {
    return axiosInstance
      .patch(`crm/message/${params.uuid}/`, params, {})
      .then((response) => {
        dispatch({
          type: UPDATE_MESSAGE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: UPDATE_MESSAGE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};


// Get Unread message count
export const getMessagesCount = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/message/unread-count/`, { params, })
      .then((response) => {
        dispatch({
          type: MESSAGE_COUNT,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: MESSAGE_COUNT_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};